module.exports = __webpack_public_path__ + "static/media/maestro_card.51881e2c.svg";